import "./src/global.css"
import wrapRootElementWithRecoil from "./wrap-root-recoil.js"

export const wrapRootElement = wrapRootElementWithRecoil
